jQuery('.service-banner .animation-container').on('click', function() {
    var bannerHeight = jQuery('.service-banner').height();
    bannerHeight = bannerHeight + 100;
    jQuery('html,body').animate({
        scrollTop: '+=' + bannerHeight + 'px'
    }, 1);
});

jQuery(document).ready(function() {
    if (jQuery('.service-banner .service-video').length) {
        // jQuery('.service-banner .content-container .content').fadeIn(1000);
        jQuery('.service-banner .content-container .content').fadeIn(300);

        jQuery('.service-banner .service-video').fadeIn(1500);

        jQuery('.service-banner .overlay').fadeIn(1000);
    }
});